import CountdownBanner from "@/components/CountdownBanner";
import HeroSection from "@/components/HeroSection";
import { lazy, Suspense } from "react";

const ABVariantSwitcher = lazy(() => import("@/components/ABVariantSwitcher"));
const QuemESection = lazy(() => import("@/components/QuemESection"));
const ReconhecimentoSection = lazy(() => import("@/components/ReconhecimentoSection"));
const DepoimentosVideoSection = lazy(() => import("@/components/DepoimentosVideoSection"));
const ParaQuemSection = lazy(() => import("@/components/ParaQuemSection"));
const ConteudoSection = lazy(() => import("@/components/ConteudoSection"));
const AgendaSection = lazy(() => import("@/components/AgendaSection"));
const ComoFuncionaSection = lazy(() => import("@/components/ComoFuncionaSection"));
const InclusoSection = lazy(() => import("@/components/InclusoSection"));
const FAQSection = lazy(() => import("@/components/FAQSection"));
const CTAFinalSection = lazy(() => import("@/components/CTAFinalSection"));
const FooterSection = lazy(() => import("@/components/FooterSection"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <CountdownBanner />
      <HeroSection />
      <Suspense fallback={<div className="min-h-[400px]" />}>
        <QuemESection />
        <ReconhecimentoSection />
        <DepoimentosVideoSection />
        <ParaQuemSection />
        <ConteudoSection />
        <AgendaSection />
        <ComoFuncionaSection />
        <InclusoSection />
        <FAQSection />
        <CTAFinalSection />
        <FooterSection />
        <ABVariantSwitcher />
      </Suspense>
    </div>
  );
};

export default Index;
